import React, { Component } from 'react'
import styled from 'styled-components'

const Veil = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
`

const ModalContainer = styled.div`
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
  background-color: #f8f9f7;
  width: 500px;
  padding: 20px;
  position: absolute;
  top: 300px;
  z-index: 9999999;
  box-sizing: border-box;
  max-height: 500px;
`

const Header = styled.header`
  display: flex;
  align-items: center;

  h2 {
      margin: 0;
      padding: 0;
      font-size: 16px;
      font-weight: 600;
  }
`

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: -10px;

  button {
    border: 0;
    color: #2e5f62;
    background: transparent;
    margin-left: 40px;
    font-weight: 700;
    padding: 10px 15px;
    cursor: pointer;

    &:hover {
      border-radius: 6px;
      background-color: rgba(33, 33, 33, 0.03);
    }
  }
`

class DeletePatientModal extends Component {
  render () {
    const { handleClose, handleDeletePatient } = this.props

    return (
      <Veil onClick={handleClose}>
        <ModalContainer onClick={e => e.stopPropagation()}>
          <Header>
            <h2>Remove this patient from your list?</h2>
          </Header>

          <ButtonGroup>
            <button onClick={handleClose}>CANCEL</button>
            <button onClick={handleDeletePatient}>REMOVE</button>
          </ButtonGroup>

        </ModalContainer>
      </Veil>
    )
  }
}
export default DeletePatientModal
